import vanillaMasker from 'vanilla-masker';
import { convertFloatToMoney } from './helpers';

export const convertToMoney = (value) => {
  if (!value) {
    return 'R$ 0,00';
  }
  const valor = convertFloatToMoney(value);
  if (value < 0) {
    return `R$ -${vanillaMasker.toMoney(valor)}`;
  }
  return `R$ ${vanillaMasker.toMoney(valor)}`;
};

export const convertToPercent = (value) => {
  if (!value) {
    return '0,00 %';
  }
  const valor = convertFloatToMoney(value);
  if (value < 0) {
    return `-${vanillaMasker.toMoney(valor)} %`;
  }
  return `${vanillaMasker.toMoney(valor)} %`;
};

export const convertToNumberFormat = (value) => {
  if (!value) {
    return '0';
  }
  const valor = convertFloatToMoney(value);
  if (value < 0) {
    return `-${vanillaMasker.toMoney(valor)}`;
  }
  return `${vanillaMasker.toMoney(valor)}`;
};

export const numberBetweenValues = (n, a, b) => a <= n && (!b || b >= n);

export const getMoney = (value) => {
  if (value === null || value === undefined) return '0';
  const num = parseFloat(value) || 0;
  return num.toFixed(2)
    .replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    .replace('.', ',');
};

export const formatarUnidades = (valor, precisao = 0) => {
  if (valor === null || valor === undefined || valor === 0) {
    return '0';
  }

  const formatarNumero = (num) => {
    if (precisao > 0) {
      const formatado = num.toFixed(precisao).replace('.', ',');
      return formatado.replace(/,00$/, '');
    }
    return Math.round(num).toString();
  };

  if (valor < 1000) {
    return formatarNumero(valor);
  }
  if (valor < 1000000) {
    return `${formatarNumero(valor / 1000)} Mil`;
  }
  return `${formatarNumero(valor / 1000000)} Mi`;
};
